import React from 'react';
import { Tooltip, TrevorComponent } from '@trevor/ui-components';
import AggregateFunction from '@/util/AggregateFunction';
import TableRef from '@/util/TableRef';
import ColumnName from '@/util/ColumnName';
import { StepValue } from '@/views/QueryBuilder/subcomponents/Steps';
import { openMetricsDropdown } from '@/components/layers/LayerAggregate/layerAggregateSlice';
import { PlusButton } from '@/views/QueryBuilder/subcomponents/PlusButton';
import { useAppDispatch } from '@/store/hooks';
import styled from 'styled-components';

export type MetricsReadOnlyModeProps = {
  functions: AggregateFunction[];
  editLayerClicked: F0;
  aliases: Record<string, TableRef>;
  layerId: number;
  pks: ColumnName[];
};

const MetricsEmptyWrapper = styled.div`
  display: flex;
  align-items: center;
  margin-right: var(--spacing-xxs);
  font-size: 12px;
`;

export const MetricsReadOnlyMode: TrevorComponent<MetricsReadOnlyModeProps> = ({
  functions,
  aliases,
  editLayerClicked,
  layerId,
  pks,
}) => {
  const dispatch = useAppDispatch();

  if (functions.length === 0) {
    return (
      <MetricsEmptyWrapper onClick={editLayerClicked}>
        Metrics
        <PlusButton onClick={() => dispatch(openMetricsDropdown(true))} />
      </MetricsEmptyWrapper>
    );
  }

  return (
    <>
      {functions.map((fun, index) => {
        const label =
          (fun.metricColumnName || fun.toString(pks, aliases)) +
          (fun.clauses ? '*' : '');
        const columnName = fun.columnName();
        return (
          <span key={`metric_${index}`}>
            <StepValue
              $type="summarise"
              onClick={editLayerClicked}
              data-tooltip-id={`metric_${index}_${layerId}`}
            >
              {label}
            </StepValue>
            {columnName && (
              <Tooltip id={`metric_${index}_${layerId}`}>
                {aliases[columnName.alias()]
                  ? `${aliases[columnName.alias()].name()}.${columnName.name()}`
                  : `custom.${columnName.name()}`}
              </Tooltip>
            )}
          </span>
        );
      })}
    </>
  );
};
